// extracted by mini-css-extract-plugin
export default {"page":"Lectures_page__jalS8","container":"Lectures_container__aijzp","header":"Lectures_header__IK5Qr","bar":"Lectures_bar__nHIqI","table":"Lectures_table__2USUE"};